import '@css/app.css';

import { videoEmbed } from '@js/src/videoEmbed';
import { toggle } from '@js/src/toggle';
import { menu } from '@js/src/menu';
import gravityForms from '@js/src/integrations/gravityForms';
import flickitySliders from '@js/src/integrations/flickity';
import Theme from '@js/src/Theme';
import { addClassForAndroid, helpers, onDomReady } from '@js/src/helpers';
import googleMaps from '@js/src/googleMaps';
import { initFavourites } from '@js/src/favourites';
import googleMapsAddressSearch from '@js/src/googleMapsAddressSearch';
import { sortableTable } from '@js/src/tables';
import { copy } from '@js/src/copy';
import { share } from '@js/src/share';
import { smoothScroll } from '@js/src/smoothScroll';

onDomReady(function () {
    const LandedHouses = Theme;
    window.LandedHouses = LandedHouses;

    LandedHouses.setCallables([
        helpers,
        addClassForAndroid,
        toggle,
        menu,
        videoEmbed,
        sortableTable,
        copy,
        share,
        initFavourites,
        smoothScroll,
        flickitySliders,
        gravityForms,
        googleMaps,
        googleMapsAddressSearch
    ]);

    LandedHouses.init();
});
